import type {MergeContext, QuoteTemplate} from './types';
import {resolvePlateValue} from './resolvePlateValue';

/**
 * Replaces every mention node in the template's narrative sections with its resolved value.
 * The result is what gets rendered AND what gets persisted, so a published document needs no
 * merge context.
 */
export function resolveTemplate(template: QuoteTemplate, ctx: MergeContext): QuoteTemplate {
	return {
		...template,
		introduction: resolvePlateValue(template.introduction, ctx),
		scopeOfWork: resolvePlateValue(template.scopeOfWork, ctx),
		terms: resolvePlateValue(template.terms, ctx),
	};
}
